import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-export-ready-banner",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./export-ready-banner.component.html",
  styleUrl: "./export-ready-banner.component.scss",
})
export class ExportReadyBannerComponent {
  @Input({ required: true }) messageKey!: string;
  @Input({ required: true }) actionLabelKey!: string;
  @Input() dismissLabelKey = "COMMON.CLOSE";
  @Output() action = new EventEmitter<void>();
  @Output() dismiss = new EventEmitter<void>();
}
